import { render, staticRenderFns } from "./LogLegajoFisico.vue?vue&type=template&id=7cb36dae"
import script from "./LogLegajoFisico.vue?vue&type=script&lang=js"
export * from "./LogLegajoFisico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports